import { useQuery } from '@tanstack/react-query'
import { useUI } from '@/store/ui'
import { checkAllServices } from '@/api/services'
import { Button, Card, StatusDot, Table, Tbody, Td, Th, Thead, Tr } from '@diwata/ironvale'

export function Services() {
  const { daemonUrl, conclaveUrl, assayUrl, loreUrl, gatewayUrl } = useUI()

  const { data: statuses = [], isLoading, refetch } = useQuery({
    queryKey: ['health'],
    queryFn: () => checkAllServices({ daemon: daemonUrl, conclave: conclaveUrl, assay: assayUrl, lore: loreUrl, gateway: gatewayUrl }),
    refetchInterval: 30_000,
  })

  const healthy = statuses.filter((s) => s.healthy).length
  const total = statuses.length

  return (
    <div>
      <div className="ap-page-header">
        <div>
          <div className="ap-page-title">Services</div>
          {!isLoading && (
            <div className="ap-page-subtitle">{healthy}/{total} healthy</div>
          )}
        </div>
        <Button variant="ghost" size="sm" onClick={() => refetch()}>Refresh</Button>
      </div>

      <Card>
        {isLoading && <p className="ap-empty">Checking…</p>}
        <Table>
          <Thead>
            <Tr>
              <Th style={{ width: 20 }} />
              <Th>Service</Th>
              <Th>URL</Th>
              <Th>Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {statuses.map((s) => (
              <Tr key={s.name}>
                <Td><StatusDot color={s.healthy ? 'green' : 'red'} /></Td>
                <Td className="ap-service-name">{s.label}</Td>
                <Td className="ap-service-status">{s.url}</Td>
                <Td style={{ color: s.healthy ? 'var(--ae-color-feedback-success)' : 'var(--ae-color-feedback-error)' }}>
                  {s.healthy ? 'healthy' : 'unreachable'}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Card>
    </div>
  )
}
